import styles from '../shared.module.scss'

export default {
  root: {
    minWidth: '320px',
  },
}
